import { branchesInfo, newBranches, newofBranch } from "../api/branch";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    branches:[],
    news:[],
    newBranch:[],
    loadingNew :false
}
export const branchSlice = createSlice({
    name:'branches',
    initialState,
   
    extraReducers:{
        [branchesInfo.fulfilled]:(state,{payload}) =>{  
            state.branches = payload
        },
        [newofBranch.pending]:(state,{payload}) =>{  
          return {
            ...state,
            news:[],
            loadingNew:true
           }
        },
        [newofBranch.fulfilled]:(state,{payload}) =>{  
            return {
                ...state,
                news:payload,
                loadingNew:false
               }
        },
        [newBranches.pending]:(state,{payload}) =>{  
          return {
            ...state,
            newBranch:[],
            loadingNew:true
           }
        },
        [newBranches.fulfilled]:(state,{payload}) =>{  
            return {
                ...state,
                newBranch:payload,
                loadingNew:false
               }
        },
       
     
    }
})


export default branchSlice.reducer